/**
 * password.js
 *
 * Opens and closes the passcode overlay.
 *
 * The password itself is never checked here — the form posts to Shopify's
 * `storefront_password` endpoint. On a wrong password Shopify re-renders this
 * page with an error node inside the form, and that node is the signal to
 * reopen the overlay: Liquid's `form` object is not in scope outside the form
 * block, so the markup cannot know on its own.
 */

function init() {
  const toggle = document.querySelector('[data-password-toggle]');
  const panel = document.querySelector('[data-password-panel]');
  if (!toggle || !panel) return;

  const closeButton = panel.querySelector('[data-password-close]');
  const field = panel.querySelector('input[type="password"]');
  const hasError = Boolean(panel.querySelector('[role="alert"]'));

  const setOpen = (open, { focus = true } = {}) => {
    panel.hidden = !open;
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.style.overflow = open ? 'hidden' : '';

    if (open && focus) {
      requestAnimationFrame(() => field?.focus());
    } else if (!open) {
      toggle.focus();
    }
  };

  toggle.addEventListener('click', () => setOpen(true));
  closeButton?.addEventListener('click', () => setOpen(false));

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !panel.hidden) setOpen(false);
  });

  // A failed attempt reloads the page — reopen so the visitor sees why, with
  // the wrong value selected so they can just type over it.
  if (hasError) {
    panel.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(() => field?.select());
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}
